import { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Search } from "lucide-react";
import { LogoMark } from "./Logo";
import { WhatsAppIcon } from "./icons";
import { IMAGES } from "@/lib/constants";

const CARDS = [
  {
    id: "piso-valencia",
    kind: "alquiler",
    badge: "Alquiler",
    title: "Piso luminoso",
    price: "750 €/mes",
    city: "Valencia",
    img: IMAGES.apartment,
  },
  {
    id: "casa-sevilla",
    kind: "venta",
    badge: "Venta",
    title: "Casa con patio",
    price: "189.000 €",
    city: "Sevilla",
    img: IMAGES.house,
  },
];

export default function PhoneMockup() {
  const [tab, setTab] = useState("alquiler");

  return (
    <motion.div
      animate={{ y: [0, -10, 0] }}
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      className="relative"
      data-testid="phone-mockup"
    >
      <div className="rounded-[2.8rem] border border-white/15 bg-[#0a1a2b] p-2.5 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.6)]">
        <div className="overflow-hidden rounded-[2.2rem] bg-[#f7f4ee]">
          <div className="flex items-center justify-between bg-[#0f766e] px-5 pb-4 pt-5">
            <span className="inline-flex items-center gap-1.5">
              <LogoMark className="h-6 w-6" />
              <span className="font-serif text-sm font-semibold text-white">Nidoria</span>
            </span>
            <span className="h-1.5 w-10 rounded-full bg-white/25" aria-hidden="true" />
          </div>

          <div className="space-y-3.5 px-4 pb-6 pt-4">
            <p className="font-serif text-lg font-semibold text-[#12263a]">¿Dónde quieres vivir?</p>

            <div className="flex items-center gap-2 rounded-full bg-white px-4 py-2.5 text-xs font-semibold text-[#12263a]/50 shadow-sm">
              <Search className="h-3.5 w-3.5 text-[#0f766e]" />
              Ciudad, zona, barrio…
            </div>

            <div className="grid grid-cols-2 gap-1 rounded-full bg-[#12263a]/5 p-1" role="tablist" aria-label="Tipo de operación">
              {["alquiler", "venta"].map((k) => (
                <button
                  key={k}
                  role="tab"
                  aria-selected={tab === k}
                  data-testid={`mockup-tab-${k}`}
                  onClick={() => setTab(k)}
                  className={`rounded-full py-1.5 text-xs font-bold capitalize transition-colors duration-200 ${
                    tab === k ? "bg-[#0f766e] text-white" : "text-[#12263a]/60"
                  }`}
                >
                  {k === "alquiler" ? "Alquiler" : "Venta"}
                </button>
              ))}
            </div>

            {CARDS.map((card) => {
              const active = card.kind === tab;
              return (
                <motion.article
                  key={card.id}
                  layout
                  animate={{ opacity: active ? 1 : 0.55, scale: active ? 1 : 0.98 }}
                  transition={{ duration: 0.35 }}
                  className={`overflow-hidden rounded-2xl bg-white shadow-sm ${active ? "ring-2 ring-[#14b8a6]" : ""}`}
                  data-testid={`mockup-card-${card.id}`}
                >
                  <div className="relative">
                    <img src={card.img} alt={`${card.title} en ${card.city}`} className="h-24 w-full object-cover" loading="lazy" />
                    <span
                      className={`absolute left-2.5 top-2.5 rounded-full px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-white ${
                        card.kind === "alquiler" ? "bg-[#0f766e]" : "bg-[#f59e0b]"
                      }`}
                    >
                      {card.badge}
                    </span>
                  </div>
                  <div className="space-y-1 px-3.5 py-3">
                    <div className="flex items-baseline justify-between gap-2">
                      <p className="text-sm font-bold text-[#12263a]">{card.title}</p>
                      <p className="text-sm font-extrabold text-[#0f766e]">{card.price}</p>
                    </div>
                    <div className="flex items-center justify-between">
                      <p className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#12263a]/55">
                        <MapPin className="h-3 w-3" />
                        {card.city}
                      </p>
                      <span className="inline-flex items-center gap-1 rounded-full bg-[#25D366]/15 px-2 py-1 text-[10px] font-bold text-[#128C4B]">
                        <WhatsAppIcon className="h-3 w-3" />
                        Consultar
                      </span>
                    </div>
                  </div>
                </motion.article>
              );
            })}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
